import type { SVGProps } from 'react';

export function CropIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M4 15h2v4h4v2H4v-6zm16-6h-2V5h-4V3h6v6zM4 9h2V5h4V3H4v6zm16 6h-2v4h-4v2h6v-6z" />
    </svg>
  );
}

export default CropIcon;
